"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createContainer = exports.modules = exports.core = void 0;
require("reflect-metadata");
const inversify_1 = require("inversify");
const RetailClient_1 = require("./RetailClient");
const SalesOrder_1 = require("../models/SalesOrder");
const RetailSession_1 = require("../models/RetailSession");
const RetailLocation_1 = require("../models/RetailLocation");
const RetailAuthModule_1 = require("./modules/RetailAuthModule");
const RetailSalesOrdersModule_1 = require("./modules/RetailSalesOrdersModule");
const RetailCustomersModule_1 = require("./modules/RetailCustomersModule");
const RetailLocationsModule_1 = require("./modules/RetailLocationsModule");
const RetailProductsModule_1 = require("./modules/RetailProductsModule");
const HttpConnection_1 = require("../../../../apis/spg/client/connections/HttpConnection");
const WebSocketConnection_1 = require("../../../../apis/spg/client/connections/WebSocketConnection");
const SyncModule_1 = require("../../../../apis/spg/client/modules/SyncModule");
const GeoModule_1 = require("../../../../apis/spg/client/modules/GeoModule");
// TODO move legals module into ordering/client/modules folder
const LegalsModule_1 = require("../../../../apis/zam/client/modules/LegalsModule");
const ContentModule_1 = require("../../../../apis/spg/client/modules/ContentModule");
exports.core = new inversify_1.ContainerModule((bind) => {
    bind("RetailClient")
        .to(RetailClient_1.RetailClient)
        .inRequestScope();
    bind("HttpConnection")
        .to(HttpConnection_1.HttpConnection)
        .inRequestScope();
    bind("WebSocketConnection")
        .to(WebSocketConnection_1.WebSocketConnection)
        .inRequestScope();
    bind("interfaces.Newable<SalesOrder>").toConstructor(SalesOrder_1.SalesOrder);
    bind("interfaces.Newable<RetailSession>").toConstructor(RetailSession_1.RetailSession);
    bind("interfaces.Newable<RetailLocation>").toConstructor(RetailLocation_1.RetailLocation);
});
exports.modules = new inversify_1.ContainerModule((bind) => {
    bind("GeoModule")
        .to(GeoModule_1.GeoModule)
        .inRequestScope();
    bind("AuthModule")
        .to(RetailAuthModule_1.RetailAuthModule)
        .inRequestScope();
    bind("SyncModule")
        .to(SyncModule_1.SyncModule)
        .inRequestScope();
    bind("LegalsModule")
        .to(LegalsModule_1.LegalsModule)
        .inRequestScope();
    bind("RetailSalesOrdersModule")
        .to(RetailSalesOrdersModule_1.RetailSalesOrdersModule)
        .inRequestScope();
    bind("RetailCustomersModule")
        .to(RetailCustomersModule_1.RetailCustomersModule)
        .inRequestScope();
    bind("RetailLocationsModule")
        .to(RetailLocationsModule_1.RetailLocationsModule)
        .inRequestScope();
    bind("RetailProductsModule")
        .to(RetailProductsModule_1.RetailProductsModule)
        .inRequestScope();
    bind("ContentModule")
        .to(ContentModule_1.ContentModule)
        .inRequestScope();
});
function createContainer() {
    const container = new inversify_1.Container();
    container.load(exports.core, exports.modules);
    return container;
}
exports.createContainer = createContainer;
//# sourceMappingURL=container.js.map